let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fgy6J")).then(() => parcelRequire('9QTmV'));